import { Module }    from 'vuex';
import { RootState } from '@/store/store.types';
import { State }     from '@/views/changelog-settings/changelog-settings.types';
import actions       from '@/views/changelog-settings/store/changelog-settings.actions';
import state         from '@/views/changelog-settings/store/changelog-settings.state';
import mutations     from '@/views/changelog-settings/store/changelog-settings.mutations';

const store: Module<State, RootState> = {
  namespaced: true,
  state,
  actions,
  mutations,
};

export default store;
